import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Spin, Switch, Select } from "antd";
import { ROLL_CALL_API_BASE_URL } from "../../RollCall/RollCallConfig/RollCallConfig";
import Table from "../../../../core/pagination/datatable";
import UploadBulkVisitor from "./UploadBulkVisitor";
const { Option } = Select;

const EventVisitors = () => {
  const location = useLocation();
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [visitorsData, setVisitorsData] = useState([]);
  const [events, setEvents] = useState([]);
  const [selectedEventId, setSelectedEventId] = useState(null);
  const [hasAttended, setHasAttended] = useState(0);

  const [loading, setLoading] = useState(false);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;
    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchEvents = async () => {
    try {
      setEventsLoading(true);

      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}Visitor/Pass/getVisitorEvents?SuperId=${superIdData}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${tokenData}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      if (data?.status) {
        const eventList = data.ResultData || [];

        setEvents(eventList);
        if (eventList.length > 0) {
          setSelectedEventId(eventList[0].Id);
        }
      }
    } catch (error) {
      console.error("Error fetching visitor events:", error);
    } finally {
      setEventsLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [superIdData, tokenData]);

  const fetchVisitorEvents = async () => {
    if (tokenData && superIdData) {
      setLoading(true);

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}Visitor/Pass/getVisitorsForEvent?HasAttended=${hasAttended}&EventId=${selectedEventId}&SuperId=${superIdData}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const data = await response.json();

        if (data.status) {
          setVisitorsData(data.ResultData || []);
        } else {
          console.error("Failed to fetch visitor events");
        }
      } catch (error) {
        console.error("Error fetching visitor events:", error.message);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (tokenData && superIdData) {
      fetchVisitorEvents();
    }
  }, [tokenData, superIdData, selectedEventId, hasAttended]);

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      sorter: (a, b) => (a?.Name || "").localeCompare(b?.Name || ""),
      render: (text) => text || "N/A",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      sorter: (a, b) => Number(a?.Mobile || 0) - Number(b?.Mobile || 0),
      render: (count) => count ?? "N/A",
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a, b) => (a?.Email || "").localeCompare(b?.Email || ""),
      render: (text) => text || "N/A",
    },
    {
      title: "CompanyName",
      dataIndex: "CompanyName",
      sorter: (a, b) =>
        (a?.CompanyName || "").localeCompare(b?.CompanyName || ""),
      render: (text) => text || "N/A",
    },

    {
      title: "Has Attended",
      dataIndex: "HasAttended",
      key: "HasAttended",
      sorter: (a, b) => (a?.HasAttended ? 1 : 0) - (b?.HasAttended ? 1 : 0),
      render: (isActive) => (
        <Switch
          checked={Boolean(isActive)}
          style={{
            transform: "scale(0.8)",
            transformOrigin: "left center",
          }}
        />
      ),
    },
  ];

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Event visitors
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your visitors for the event</h6>
              </div>
            </div>

            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsBulkUploadOpen(true);
                  }}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                <div className="search-set"></div>
                <div className="d-flex right-content align-items-end row">
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 180 }}
                  >
                    <div className="col-4">
                      <Select
                        placeholder="Select Event"
                        style={{ width: 170, height: 37 }}
                        value={selectedEventId}
                        onChange={(value) => {
                          setSelectedEventId(value);
                        }}
                        loading={eventsLoading}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      >
                        {events.map((event) => (
                          <Option key={event.Id} value={event.Id}>
                            {event.Name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div
                    className="form-control p-0 border-0"
                    style={{ width: 180 }}
                  >
                    <div className="col-4">
                      <Select
                        style={{ width: 170, height: 37 }}
                        value={hasAttended}
                        placeholder="Attendance"
                        onChange={(value) => {
                          setHasAttended(value);
                        }}
                      >
                        <Select.Option value={null}>All</Select.Option>
                        <Select.Option value={1}>Presenties</Select.Option>
                        <Select.Option value={0}>Absenties</Select.Option>
                      </Select>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large"></Spin>
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={visitorsData}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
      </div>
      <UploadBulkVisitor
        open={isBulkUploadOpen}
        onClose={() => setIsBulkUploadOpen(false)}
      />
    </div>
  );
};

export default EventVisitors;
